import {
    getAllTrackingRouteLoading,
    getAllTrackingRouteSuccess,
    getAllTrackingRouteReject,
    getAllTrackingRouteRequest
} from "../../actions/home/getAllOnRoutes";

export const getAllOnRoutes = (formData) => async (dispatch, getState) => {
    dispatch(getAllTrackingRouteLoading());
    try {
        const { data } = await getAllTrackingRouteRequest(formData, getState);
        dispatch(getAllTrackingRouteSuccess(data))
    } catch (error) {
        dispatch(getAllTrackingRouteReject(error))
    }
    return Promise.resolve();
};